import * as types from '../actions/actionTypes';
import { IEquipmentAlertState } from '../models';

const initialState: IEquipmentAlertState = {
    installbaseIDs: [],
    hasAlerts: false,
    facilityID: null,
    isLoading: false,
    error: null
};

export default function equipmentAlertReducer(
    state: IEquipmentAlertState = initialState,
    action: any
): IEquipmentAlertState {
    switch (action.type) {
        case types.BEGIN_AJAX_CALL:
            return {
                ...state,
                isLoading: true,
                error: null
            };

        case types.LOAD_EQUIPMENT_ALERTS_SUCCESS:
            return {
                ...state,
                installbaseIDs: action.payload.installbaseIDs,
                hasAlerts: action.payload.hasAlerts,
                facilityID: action.payload.facilityID,
                isLoading: false,
                error: null
            };

        case types.LOAD_EQUIPMENT_ALERTS_FAILED:
            return {
                ...state,
                isLoading: false,
                error: action.error,
                facilityID: action.facilityID
            };

        default:
            return state;
    }
}
